import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { HOMEPAGE_GALLERY_TILE_COUNT } from './homepageCarousel.constants';
import {
  columnSx,
  featuredFrameSx,
  gridSx,
  panelSx,
  rowSx,
  sectionSx,
  shimmerFillSx,
  tileFrameSx,
  tileRowSx,
} from './destinationGalleryLayout';

function ShimmerCard({ featured }) {
  return (
    <Box sx={featured ? featuredFrameSx : tileFrameSx} aria-hidden="true">
      <Skeleton variant="rounded" animation="wave" sx={shimmerFillSx} />
    </Box>
  );
}

/**
 * Same box sizes as the loaded gallery. Homepage uses it as the Suspense fallback so the
 * sections below do not jump when the gallery chunk arrives.
 */
export default function DestinationGallerySkeleton() {
  const slots = Array.from({ length: HOMEPAGE_GALLERY_TILE_COUNT }, (_, index) => index);
  return (
    <Box
      component="section"
      aria-label="Popular destinations"
      aria-busy
      data-testid="destination-gallery-shimmer"
      sx={sectionSx}
    >
      <Box sx={panelSx}>
        <Box sx={columnSx}>
          <Box sx={rowSx}>
            <ShimmerCard featured />
            <Box sx={gridSx}>
              {[slots.slice(0, 2), slots.slice(2, 4)].map((row) => (
                <Box key={row[0]} sx={tileRowSx}>
                  {row.map((slot) => <ShimmerCard key={slot} />)}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
